import styled from 'styled-components';
import {
  NavLink,
} from 'react-router';

import {
  Flex,
  icons,
} from 'web-styled';

export const Sidebar = styled(Flex).attrs({
  flex: '0 0 230px',
  width: '230px',
  column: true,
})`
  height: 100%;
  transition: flex .5s ease;
  box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.04);
  background: ${props => props.theme.colors.bgBlack};

  @media print {
    display: none;
  }
`;

type LogoProps = {
  logo: string | null;
};

export const Logo = styled(NavLink) <LogoProps>`
  flex: 0 0 64px;
  width: 230px;
  background-size: 170px;
  background-color: #23292b;
  background-image: url(${props => props.logo || icons.gymcloudLogo});
  background-repeat: no-repeat;
  background-position: center center;
`;

type LinkProps = {
  isopen?: number;
  isDraggable?: boolean;
};

export const StyledLink = styled(NavLink) <LinkProps>`
  display: flex;
  width: 100%;
  flex: 0 0 46px;
  box-sizing: border-box;
  margin: 0;
  font-size: 15px;
  font-weight: 300;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.65);
  border-left: 2px solid transparent;
  padding: 14px 7px 14px 14px;
  background-color: ${props => (props.isopen ? '#3c4248' : 'transparent')};
  position: relative;

  & > .fa,
  & > .far,
  & > .fas {
    position: relative;
    top: 3px;
    left: 1px;
    margin-right: 9px;
  }

  &:hover {
    color: #fff;
    & > span {
      opacity: 1;
      background-position: left top;
    }
  }

  // Fix Calendar Icon
  svg path[fill-rule="nonzero"] {
    fill: #fff !important;
  }
  svg path:not([fill-rule="nonzero"]) {
    stroke: #fff !important;
  }

  &.active {
    color: ${props => props.theme.colors.sidebarLink};
    border-left-color: ${props => props.theme.colors.sidebarLink};

    &:hover {
      color: ${props => props.theme.colors.sidebarLink};
    }

    & > span {
      opacity: 1;
      background-position: right top;
    }

    // Fix Calendar Icon
    svg path[fill-rule="nonzero"] {
      fill: ${props => props.theme.colors.sidebarLink} !important;
    }
    svg path:not([fill-rule="nonzero"]) {
      stroke: ${props => props.theme.colors.sidebarLink} !important;
    }
  }

  ${props => props.isDraggable && `
    cursor: move;
  `}
`;

export const SVGIcon = styled.span`
  position: relative;
  left: -3px;
  top: 0px;
  opacity: 0.65;

  svg {
    height: 18px !important;
    width: 16px !important;
  }
`;

export const Name = styled.span`
  padding: 0 0 0 5px;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  text-transform: capitalize;
  overflow-y: hidden;
  max-width: 150px;
  margin-right: 5px;
`;

export const PremiumLock = styled.span`
  width: 16px;
  height: 16px;
  margin-top: 2px;
  margin-left: 5px;
  background-image: url(data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Ccircle%20cx%3D%228%22%20cy%3D%228%22%20r%3D%228%22%20fill%3D%22%232773C1%22%2F%3E%3Cg%20opacity%3D%220.8%22%3E%3Cpath%20d%3D%22M3.88654%209.55536C3.69654%208.31974%203.50644%207.08411%203.31623%205.84849C3.30696%205.78777%203.31596%205.72566%203.34211%205.67008C3.36825%205.6145%203.41035%205.56796%203.46304%205.53639C3.51572%205.50481%203.57662%205.48964%203.63796%205.4928C3.6993%205.49595%203.75831%205.5173%203.80748%205.55411L5.58436%206.88661C5.63053%206.92126%205.68328%206.94612%205.73939%206.95967C5.79549%206.97323%205.85378%206.9752%205.91067%206.96546C5.96756%206.95572%206.02187%206.93447%206.07028%206.90302C6.11868%206.87157%206.16015%206.83058%206.19217%206.78255L7.67155%204.56255C7.70761%204.5086%207.75642%204.46438%207.81365%204.43379C7.87089%204.40321%207.93478%204.38721%207.99967%204.38721C8.06456%204.38721%208.12845%204.40321%208.18569%204.43379C8.24292%204.46438%208.29173%204.5086%208.3278%204.56255L9.80717%206.7813C9.83919%206.82933%209.88066%206.87032%209.92907%206.90177C9.97747%206.93322%2010.0318%206.95447%2010.0887%206.96421C10.1456%206.97395%2010.2038%206.97198%2010.26%206.95842C10.3161%206.94487%2010.3688%206.92001%2010.415%206.88536L12.1919%205.55286C12.241%205.51605%2012.3%205.4947%2012.3614%205.49155C12.4227%205.48839%2012.4836%205.50356%2012.5363%205.53514C12.589%205.56671%2012.6311%205.61325%2012.6572%205.66883C12.6834%205.72441%2012.6924%205.78652%2012.6831%205.84724C12.4929%207.08286%2012.3028%208.31849%2012.1128%209.55411L3.88654%209.55536Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20d%3D%22M3.88654%2010.241H12.1134V11.1832C12.1134%2011.2395%2012.1023%2011.2953%2012.0808%2011.3473C12.0592%2011.3994%2012.0276%2011.4467%2011.9877%2011.4865C11.9479%2011.5264%2011.9006%2011.558%2011.8485%2011.5796C11.7965%2011.6011%2011.7407%2011.6122%2011.6843%2011.6122H4.3156C4.2018%2011.6122%204.09267%2011.567%204.01221%2011.4865C3.93174%2011.4061%203.88654%2011.2969%203.88654%2011.1832V10.241Z%22%20fill%3D%22white%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E)
`;

export const Arrow = styled.div<{ isOpen: boolean }>`
  width: 20px;
  height: 20px;
  position: relative;
  top: 0px;
  right: -10px;
  transform: rotate(${props => (props.isOpen ? '-90deg' : '90deg')});
  background: url(${icons.sidebarArrow}) center center no-repeat;
  margin-left: auto;
  margin-right: 15px;
`;

type SupProps = {
  isOpen: boolean;
  showLine: boolean;
  leftLine: string;
};
export const Sub = styled(Flex).attrs({
  width: '100%',
  column: true,
}) <SupProps>`
  overflow: hidden;
  background: #2f3539;
  position: relative;
  transition: max-height 0s ease-out;
  max-height: ${props => (props.isOpen ? 'inherit' : 0)};
  position: relative;
  ${props => props.showLine && `
    &:before {
      display: block;
      content: "";
      position: absolute;
      bottom: 5px;
      top: 5px;
      left: ${props.leftLine};
      width: 0;
      border-left: 1px solid #fff;
      z-index: 1;
    }
  `}
`;

export const Badge = styled.span`
  color: #fff;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 50%;
  position: absolute;
  top: 12px;
  right: 12px;
  background-color: ${props => props.theme.colors.sidebarLink};
`;
